import { useState, useEffect } from "react";

// iOS detection
const isIOS =
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

function getIsPortrait() {
  if (typeof window === "undefined") return true;
  if (typeof window.matchMedia === "function") {
    return window.matchMedia("(orientation: portrait)").matches;
  }
  return window.innerHeight >= window.innerWidth;
}

/**
 * Hook to detect iOS devices in portrait orientation.
 * Used to disable Framer Motion animations that cause Safari compositor zoom issues.
 */
export function useIOSPortrait(): boolean {
  const [isIOSPortrait, setIsIOSPortrait] = useState(() => isIOS && getIsPortrait());

  useEffect(() => {
    if (!isIOS) return;

    const check = () => {
      setIsIOSPortrait(isIOS && getIsPortrait());
    };

    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);

    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);

  return isIOSPortrait;
}

export { isIOS };
